import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod/v4";

process.env.I18NEXT_DEFAULT_CONFIG_PATH = `./src/i18n/next-i18next.config.js`;

export const env = createEnv({
  /**
   * Specify your server-side environment variables schema here. This way you can ensure the app
   * isn't built with invalid env vars.
   */
  server: {
    BACKEND_URL: z.string().min(1),
    MAILER_URL: z.string().min(1),
    SECRET_COOKIE_PASSWORD: z.string().min(1),
    STRIPE_SECRET_API_KEY: z.string().min(1),
    GA4_MEASUREMENT_ID: z.string().min(1),
    GA4_API_SECRET: z.string().min(1),
    IS_DEV_SERVER: z.literal("true").optional(),
    NODE_ENV: z.enum(["development", "test", "production"]),
  },

  /**
   * Specify your client-side environment variables schema here. This way you can ensure the app
   * isn't built with invalid env vars. To expose them to the client, prefix them with
   * `NEXT_PUBLIC_`.
   */
  client: {
    NEXT_PUBLIC_STRIPE_PUBLISHABLE_API_KEY: z.string().min(1),
    NEXT_PUBLIC_SITE_URL: z.url().min(1),
    NEXT_PUBLIC_APP_VERSION: z.string().min(1),
    NEXT_PUBLIC_MAILER_BASE_URL: z.string().min(1),
  },

  /**
   * You can't destruct `process.env` as a regular object in the Next.js edge runtimes (e.g.
   * middlewares) or client-side so we need to destruct manually.
   */
  runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV,
    BACKEND_URL: process.env.BACKEND_URL,
    MAILER_URL: process.env.MAILER_URL,
    NEXT_PUBLIC_MAILER_BASE_URL: process.env.NEXT_PUBLIC_MAILER_BASE_URL,
    SECRET_COOKIE_PASSWORD: process.env.SECRET_COOKIE_PASSWORD,
    STRIPE_SECRET_API_KEY: process.env.STRIPE_SECRET_API_KEY,
    IS_DEV_SERVER: process.env.IS_DEV_SERVER,
    NEXT_PUBLIC_STRIPE_PUBLISHABLE_API_KEY:
      process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_API_KEY,
    NEXT_PUBLIC_SITE_URL: process.env.NEXT_PUBLIC_SITE_URL,
    NEXT_PUBLIC_APP_VERSION: process.env.NEXT_PUBLIC_APP_VERSION,
    GA4_API_SECRET: process.env.GA4_API_SECRET,
    GA4_MEASUREMENT_ID: process.env.GA4_MEASUREMENT_ID,
  },
  /**
   * Run `build` or `dev` with `SKIP_ENV_VALIDATION` to skip env validation.
   * This is especially useful for Docker builds.
   */
  skipValidation: !!process.env.SKIP_ENV_VALIDATION,
});
